<template>
  <section id="participantsLimit">
    <h2>{{ $t('advert.creation.titles.participantsLimit') }}</h2>
    <v-text-field :value="participantsLimit"
                  type="number"
                  min="0"
                  max="50"
                  color="secondary"
                  append-icon="mdi-close"
                  outlined
                  @input="$emit('update:participants-limit', parseInt($event))"
                  @click:append="$emit('update:participants-limit', 0)"
    />
  </section>
</template>

<script>
export default {
  name: 'AdvertCreationParticipantsLimit',
  props: {
    participantsLimit: [Number, null],
  },
  computed: {},
}
</script>

<style scoped>

</style>
